import mainAxios from "../api/mainAxios";
import QueryString from "qs";
import { toast } from "react-hot-toast";

export const getUsersList = () => {
  const query = QueryString.stringify({
    sort: ["updatedAt:desc"],
    populate: {
      secteurs: { fields: ["*"] },
      profile_image: { fields: ["url"] },
    },
  });
  return (dispatch) => {
    dispatch({ type: "GET_USERS_LIST_LOADING" });

    // Get the token from localStorage
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Authentication token not found");
      dispatch({
        type: "GET_USERS_LIST_ERROR",
        payload: "Authentication token not found",
      });
      return;
    }

    mainAxios
      .get(`api/users?${query}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        dispatch({ type: "GET_USERS_LIST", payload: response.data });
      })
      .catch((error) => {
        console.error("Error fetching users list:", error);
        dispatch({ type: "GET_USERS_LIST_ERROR", payload: error });
      });
  };
};

export const getUserData = (documentId) => {
  return async (dispatch) => {
    dispatch({ type: "GET_USER_DATA_REQUEST", payload: documentId });
    try {
      // Get the token from localStorage
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token not found");
      }

      const response = await mainAxios.get(`api/users/${documentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({ type: "GET_USER_DATA_SUCCESS", payload: response.data });
    } catch (error) {
      console.error("Error fetching user data:", error);
      dispatch({ type: "GET_USER_DATA_FAILURE", payload: error.message });
    }
  };
};

export const updateUser = (formData) => {
  return async (dispatch) => {
    try {
      // Extract id and prepare data to send
      const { id, ...dataToSend } = formData;

      // Clean up the data to send - remove any undefined or null values
      Object.keys(dataToSend).forEach((key) => {
        if (dataToSend[key] === undefined || dataToSend[key] === null) {
          delete dataToSend[key];
        }
      });

      // Get the token from localStorage
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token not found");
      }

      // Make the API call with the authorization header
      const response = await mainAxios.put(`api/users/${id}`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        toast.success("Collaborateur mis à jour avec succès");
        // Refresh the users list
        dispatch(getUsersList());
      }
    } catch (error) {
      console.error("Error updating user:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      toast.error("Erreur lors de la mise à jour du collaborateur");
    }
  };
};
// Create User Action (Admin function to create users)
export const createAccount = (userData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_USER_REQUEST" });

    // Get the current admin's token
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Vous devez être connecté pour créer un utilisateur");
    }
    // Create user directly through the users API as an admin
    const response = await mainAxios.post("api/users", {
      username: userData.email,
      email: userData.email,
      password: userData.password,
      name: userData.name,
      surname: userData.email,
      profile: userData.profile || "Collaborateur",
      confirmed: true,
      blocked: false,
      role: 1,
      provider: "local",
      phone_number: userData.phone_number,
      honoraires: userData.honoraires,
      assignSecteur: userData.assignSecteur,
      createPromoter: userData.createPromoter,
      createSecteur: userData.createSecteur,
      updateCatalogue: userData.updateCatalogue,
      responsableProgramme: userData.responsableProgramme,
      canHideShowProgramme: userData.canHideShowProgramme,
      secteurs: userData.secteurs || [],
      profile_image: userData.profile_image,
    });

    const user = response.data;

    // Dispatch success action
    dispatch({
      type: "CREATE_USER_SUCCESS",
      payload: { user },
    });

    return user;
  } catch (error) {
    console.error("Error creating user:", error);
    let errorMessage =
      "Une erreur s'est produite lors de la création de l'utilisateur";

    if (error.response && error.response.data && error.response.data.error) {
      // Handle Strapi specific error messages
      const strapiError = error.response.data.error;

      if (strapiError.message.includes("Email or Username are already taken")) {
        errorMessage = "Cette adresse email est déjà utilisée";
      } else {
        errorMessage = strapiError.message;
      }
    }

    toast.error(errorMessage);
    dispatch({ type: "CREATE_USER_FAILURE", payload: errorMessage });
    return error;
  }
};
